import React from 'react';

interface MinusProps {
  color?: string;
  size?: number | string;
}

const Minus = ({
  color = 'var(--product-btn-text)',
  size = 24,
}: MinusProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6 12H18'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Minus;
